import { useMemo } from "react"
import {
  VISUALIZATIONS_MAP,
  type VISUALIZATIONS_MAP_KEY,
} from "../constants/charts"

export default function useRequiredSourcesByWidgetIds(
  widgetIds: VISUALIZATIONS_MAP_KEY[],
) {
  return useMemo(
    () =>
      Array.from(
        new Set(
          widgetIds.reduce(
            (acc: string[], widget) => [
              ...acc,
              ...(VISUALIZATIONS_MAP[widget].requiredSources ?? []),
            ],
            [],
          ),
        ),
      ),
    [],
  )
}
